module.exports = __webpack_public_path__ + "img/21_94.7510efa9.png";